<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-card-title>
			<h2 class="ml-1">Pisma seryjne</h2>
		</v-card-title>
		<v-card-text class="ma-4">
			<v-layout row align-center mb-4>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Wybierz szablon pisma</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-autocomplete
						v-model="selectedTemplate"
						:items="templates"
						item-text="fileName"
						label="Szablon"
						aria-label="template"
						for="serial-writings-templates"
						id="serial-writings-templates"
						return-object
						clearable
					></v-autocomplete>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Wybierz adresatów pisma</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-expansion-panel
						class="ma-2"
						v-model="statusPanel"
						expand>
						<v-expansion-panel-content>
							<template v-slot:header="">
								<div>Status oferty</div>
							</template>
							<v-card class="ml-5">
								<v-checkbox v-model="statusChx.all" label="Wszystkie"
									aria-label="select all"></v-checkbox>
								<v-checkbox class="mt-0" v-model="statusChx[(item.value + '_chx').toLowerCase()]"
									v-for="(item, i) in statusList" :key="'status-' + i"
									:label="item.name" aria-label="checkbox status"></v-checkbox>
							</v-card>
						</v-expansion-panel-content>
					</v-expansion-panel>
					<v-expansion-panel
						class="ma-2"
						v-model="attributePanel"
						expand>
						<v-expansion-panel-content>
							<template v-slot:header="">
								<div>Atrybuty projektu</div>
							</template>
							<v-card class="ml-5">
								<v-checkbox v-model="attributeChx.all" label="Wszystkie"
									aria-label="select all"></v-checkbox>
								<v-layout row class="mt-0">
									<v-flex xs6>
										<v-checkbox v-model="attributeChx.isHidden"
											label="Ukryty" aria-label="hidden"></v-checkbox>
									</v-flex>
									<v-flex xs6>
										<v-checkbox v-model="attributeChx.isNotHidden"
											label="Nieukryty" aria-label="not hidden"></v-checkbox>
									</v-flex>
								</v-layout>
								<v-layout row class="mt-0">
									<v-flex xs6>
										<v-checkbox v-model="attributeChx.isArchived"
											label="Archiwalny" aria-label="archived"></v-checkbox>
									</v-flex>
									<v-flex xs6>
										<v-checkbox v-model="attributeChx.isNotArchived"
											label="Niearchiwalny" aria-label="not archived"></v-checkbox>
									</v-flex>
								</v-layout>
								<v-layout row class="mt-0">
									<v-flex xs6>
										<v-checkbox v-model="attributeChx.isAwaitingAnnexSigning"
											label="Oczekuje na podpisanie aneksu"
											aria-label="awaiting annex signing"></v-checkbox>
									</v-flex>
									<v-flex xs6>
										<v-checkbox v-model="attributeChx.isNotAwaitingAnnexSigning"
											label="Nie oczekuje na podpisanie aneksu"
											aria-label="not awaiting annex signing"></v-checkbox>
									</v-flex>
								</v-layout>
							</v-card>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-flex>
			</v-layout>

			<v-layout align-center justify-center>
				<v-btn color="primary" @click="generateWritingsDialog = true"
					class="ma-5" :disabled="!generationAllowed">
					Generuj pisma
				</v-btn>
			</v-layout>

			<v-layout row>
				<v-alert :value="true" outline type="info">
					Wysyłanie grupowych wiadomości email jest możliwe w zakładce „Komunikaty grupowe”
				</v-alert>
			</v-layout>
		</v-card-text>

		<ContestSerialWritingsDialog
			v-if="selectedTemplate"
			:value="generateWritingsDialog"
			:template="selectedTemplate"
			:status="statusChx"
			:status-list="statusList"
			:attributes="attributeChx"
			:attribute-list="attributeList"
			@close-dialog="generateWritingsDialog = false"/>
	</div>
</template>

<script>
	import ContestSerialWritingsDialog from "./components/ContestSerialWritingsDialog";
	import {Correspondence} from "@/api/generated/Correspondence";

	export default {
		name: "ContestSerialWritingsView",
		components: {ContestSerialWritingsDialog},

		computed: {
			generationAllowed () {
				return this.selectedTemplate && (Object.keys(this.statusChx).some(key => this.statusChx[key]) ||
					Object.keys(this.attributeChx).some(key => this.attributeChx[key]));
			}
		},

		watch: {
			"statusChx.all": {
				handler (value) {
					if (value) this.mapObjectProperties(this.statusChx, value);
				}
			},

			"statusChx": {
				handler (obj) {
					if (Object.keys(obj).some(key => obj[key] === false)) obj.all = false;
				},
				deep: true
			},

			"attributeChx.all": {
				handler (value) {
					if (value) this.mapObjectProperties(this.attributeChx, value);
				}
			},

			"attributeChx": {
				handler (obj) {
					if (Object.keys(obj).some(key => obj[key] === false)) obj.all = false;
				},
				deep: true
			}
		},

		methods: {
			mapObjectProperties (obj, value) {
				return Object.keys(obj).map(key => {
					if (key !== 'all') obj[key] = value;
				});
			}
		},

		created () {
			Correspondence.getContestTemplates(this, this.$route.params.id, successResponse => {
					this.templates = successResponse;
				},
				errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się załadować szablonów pism", errorResponse);
				});
		},

		data () {
			return {
				selectedTemplate: undefined,
				templates: ['a', 'b'],

				statusPanel: [],
				statusList: [
					{name: "Oczekuje na akceptację", value: "AWAITING_MAIN_BIDDER_ACCEPTANCE"},
					{name: "Oczekuje na akceptację współoferentów", value: "AWAITING_MUTUAL_BIDDERS_ACCEPTANCE"},
					{
						name: "Oczekuje na akceptację zmian przez współoferenta",
						value: "POST_CORRECTION_MUTUAL",
					},
					{
						name: "Oczekuje na akceptację zmian",
						value: "POST_CORRECTION_MAIN",
					},
					{name: "Wysłana", value: "SUBMITTED"},
					{name: "Rezerwowa", value: "RESERVED"},
					{name: "Odrzucona", value: "REJECTED"},
					{name: "Finansowana", value: "FINANCED"},
					{name: "Niefinansowana", value: "NOT_FINANCED"},
					{name: "Realizowana", value: "APPROVED"},
					{name: "Oczekuje na poprawki", value: "AWAITING_CORRECTION"},
				],
				statusChx: {
					all: false,
					awaiting_main_bidder_acceptance_chx: false,
					awaiting_mutual_bidders_acceptance_chx: false,
					post_correction_mutual_chx: false,
					post_correction_main_chx: false,
					submitted_chx: false,
					reserved_chx: false,
					rejected_chx: false,
					financed_chx: false,
					not_financed_chx: false,
					approved_chx: false,
					awaiting_correction_chx: false
				},

				attributePanel: [],
				attributeList: [
					{name: 'Ukryty', value: 'isHidden'},
					{name: 'Nieukryty', value: 'isNotHidden'},
					{name: 'Archiwalny', value: 'isArchived'},
					{name: 'Niearchiwalny', value: 'isNotArchived'},
					{name: 'Oczekuje na podpisanie aneksu', value: 'isAwaitingAnnexSigning'},
					{name: 'Nie oczekuje na podpisanie aneksu', value: 'isNotAwaitingAnnexSigning'}
				],
				attributeChx: {
					all: false,
					isHidden: false,
					isNotHidden: false,
					isArchived: false,
					isNotArchived: false,
					isAwaitingAnnexSigning: false,
					isNotAwaitingAnnexSigning: false
				},

				generateWritingsDialog: false
			};
		}
	};
</script>

<style scoped>

</style>